export class KePackDataModel {
	header = ['packages_data', 'v_1_0'];

	containers: {
		type: string;
		width: number;
		height: number;
		length: number;
		packagings: number[];
	}[] = [];

	packagings: {
		info: {
			name: string;
			type: string;
			color: string;
			count: number;
			stackable?: any;
		};
		code: {
			technical: string;
			commercial: string;
		};
		geometry: {
			height: number;
			width: number;
			depth: number;
		};
		weight: {
			net: number;
			gross: number;
		};
		codiciCommercialiNelGruppo: any[];
	}[] = [];
}
